import { makeAuthenticatedRequest } from "./authApi";
import { getApiUrl } from "../utils/envConfig";

export const fetchCswapStatus = () =>
  makeAuthenticatedRequest(`${getApiUrl()}/admin/cswap`, {}, 1);
